// extracted by mini-css-extract-plugin
export default {"layoutSelector":"BottomBar_layoutSelector__H0gPU"};